import React, { useContext } from 'react';
import { Button, CircularProgress, Paper, Typography } from '@mui/material';
import { useQueryFetch } from './useQueryFetch';
import { store } from './store';
import Setup2FADlg from './Setup2FADlg';
import { column } from './commonCSS';
import Disable2FA from './Disable2FADlg';

const useFetch2FASettings = () => {
	const { data, isLoading } = useQueryFetch(
		'fetch2fasettings',
		'/account/2fa/settings'
	);
	return { data, isLoading };
};

const Setup2FA = () => {
	const { data, isLoading } = useFetch2FASettings();
	const { dispatch } = useContext(store);

	function open2FASettings() {
		if (!data?.tfa) {
			dispatch({
				title: 'Set up two factor authentication',
				type: 'open dialog',
				sx: { maxWidth: '500px', margin: '0 auto', height: 'auto' },
				dlgCmp: <Setup2FADlg />,
				fullScreen: false,
				options: { disableBackdropClose: true }
			});
		} else {
			dispatch({
				title: 'Disable 2FA',
				type: 'open dialog',
				sx: { maxWidth: '500px', margin: '0 auto', height: 'auto' },
				dlgCmp: <Disable2FA method={data.method} />,
				fullScreen: false,
				options: { disableBackdropClose: true }
			});
		}
	}
	if (isLoading) return <CircularProgress />;

	return (
		<Paper css={column} sx={{ p: 4 }}>
			<Typography variant="h6">TWO FACTOR AUTHENTICATION</Typography>
			<Typography variant="body2">
				{!data?.tfa
					? `You have not set up two factor authentication. Please set up two
				factor authentication to secure your account.`
					: `Two factor authentication is enabled (${
							data.method === 'email' ? 'email code' : 'authenticator app'
					  }).`}
			</Typography>
			<Button
				sx={{ alignSelf: 'flex-end', mt: 4 }}
				variant="contained"
				onClick={e => {
					open2FASettings();
				}}>
				{data?.tfa ? 'Disable' : 'Set up'} 2FA
			</Button>
		</Paper>
	);
};

export default Setup2FA;
